
import ApiHelper from '@/common/ApiHelper'
const api = new ApiHelper();
const movieUrl = {
}
const movieRequest = {
  movieUrl,
  /** 获取导航 */
  GetUrlTime: () => {
    return api.GetUrlTime();
  },
}
export default movieRequest
